import {time_cycle, available_ranges_for_time_cycle, protocols} from '../../constants';


export function computeTimeCycle(island) {
  let timeCycle = 0;
  const islandProtocolName = island.protocol?.name;

  if (available_ranges_for_time_cycle.includes(island?.configuration?.rangeInfo?.rangeName)) {
    const nbIOModules = island?.configuration?.ioModules.length || 0;
    const bytesUsage = island?.configuration?.bytesUsage;
    let timeCycleTable;
    let currentTableValue;
    if (protocols.eip === islandProtocolName) {
      timeCycleTable = time_cycle.eip;
      currentTableValue = timeCycleTable[0];
      for (let i = 0; i < timeCycleTable.length && (timeCycleTable[i].maxModules < nbIOModules || timeCycleTable[i].maxBytes < bytesUsage); i++) {
        currentTableValue = timeCycleTable[i];
      }
      timeCycle = currentTableValue.time_cycle;

    } else if (protocols.sercos === islandProtocolName) {
      timeCycleTable = time_cycle.sercos;
      currentTableValue = timeCycleTable[0];
      for (let i = 0; i < timeCycleTable.length && (timeCycleTable[i].maxModules < nbIOModules || timeCycleTable[i].maxBytes < bytesUsage); i++) {
        currentTableValue = timeCycleTable[i];
      }
      timeCycle = currentTableValue.time_cycle;
    }
  }

  return timeCycle;
}
